import { Component, OnInit } from '@angular/core';
import { UnapprovedRemittancesTableHelper } from './unapproved-remittances.tableHelper';
import { RemittanceUnapprovedService } from "../../../services/remittance-unapproved.service";
import { UnapprovedRemittance } from "../../../models/unapproved-remittance.model";
import { FilterCriteria } from "../../../models/filter-criteria";
import { GlobalFilterService } from "../../../services/global-filter.service";
import { Router } from "@angular/router";
import { AuthorizationService } from "../../../services/authorization.service";
import { DepositService } from "../../../services/deposit-api.service";

@Component({
    selector: 'app-unapproved-remittances',
    templateUrl: './unapproved-remittances.component.html',
    styleUrls: ['./unapproved-remittances.component.css']
})
export class UnapprovedRemittancesComponent implements OnInit {

    // Helpers
    readonly tableHelper: UnapprovedRemittancesTableHelper;

    // Members
    clientId: string;
    totalItemCount: number;
    tableLoading: boolean;
    rowStyleBinding: any;

    // FilterCriteria(<sort column>, <direction>, <row limit>, <offset>)
    private filterCriteria = new FilterCriteria('DateSubmitted', 1, 10, 0);

    get rowLimit(): number {
        return this.filterCriteria.limit;
    }

    unapprovedRemittances: UnapprovedRemittance[];

    constructor(
        private unapprovedRemittancesService: RemittanceUnapprovedService,
        private router: Router,
        private globalFilterService: GlobalFilterService,
        private depositService: DepositService,
    ) {
        this.tableHelper = new UnapprovedRemittancesTableHelper();
        if (this.globalFilterService.selectedEnvironment) {
            this.clientId = this.globalFilterService.selectedEnvironment.ClientId4Digit.trim();
        }
        this.rowStyleBinding = (e) => {
            return this.rowStyle(e);
        };
    }

    ngOnInit() {
        this.loadData();
    }

    paginate(event) {
        this.filterCriteria.offset = event.first;
        this.loadData();
    }

    sort(event) {
        this.filterCriteria.sort = event.field;
        this.filterCriteria.sortOrder = event.order;
        this.filterCriteria.offset = 0
        this.loadData();
    }

    onRowSelect(event): void {
        if (this.globalFilterService.selectedClientId == event.data.ClientId) {
            this.tableLoading = true;
            this.depositService.searchDeposits(this.globalFilterService.selectedClientId,
                {
                    Payer_ShardPayerIdentifier: event.data.CarrierId,
                    Check_CheckNumber: event.data.CheckNum,
                    Check_CheckAmount: event.data.CheckAmount,
                }, 15, 0, undefined, undefined)
                .then((data) => {
                    // Because the search doesn't guarentee a single result, we
                    // have to check to ensure we open the correct batch
                    for (const check of data.Items) {
                        if (check["Check_Ref_Number"] === event.data.CheckRef) {
                            this.router.navigate(["remittanceentry", check]);
                            return;
                        }
                    }
                    // TODO: Cleanup record if it's not found in the deposit search
                    toastr.error("Check not found");
                    this.tableLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.tableLoading = false;
                });

        } else {
            toastr.info("Selected check is from another client environment");
        }
    }

    async loadData(): Promise<void> {
        this.tableLoading = true;
        await
        this.unapprovedRemittancesService.loadUnapprovedRemittances(this.clientId,
            this.filterCriteria)
            .then((data) => {
                // The DateSubmitted needs to be reparsed from a UTC date string into a proper date object
                this.unapprovedRemittances = JSON.parse(JSON.stringify(data.Items), (key, value) => {
                    if (typeof value === 'string' && key === 'DateSubmitted') {
                        return new Date(value + 'Z');
                    }
                    return value;
                });
                this.totalItemCount = data.TotalItemCount;
                this.tableLoading = false;
            })
            .catch((error: any) => {
                this.tableLoading = false;
            });
    }

    rowStyle(entry: UnapprovedRemittance): string {
        if (entry.ClientId.toString() !== this.clientId) {
            return "disabled";
        }
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/app/components/deposit-search/unapproved-remittances/unapproved-remittances.component.ts